"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var head = document.head || document.getElementsByTagName('head')[0] || document.body;
function addlink(link) {
    var csslinker = document.createElement('link');
    csslinker.rel = 'stylesheet';
    csslinker.href = link;
    head.appendChild(csslinker);
}
exports.addlink = addlink;
//# sourceMappingURL=styling.js.map